module.exports = __webpack_public_path__ + "img/311124f.jpg";